import React, { useState } from 'react';
import RoomAvailabilityCalendar from '../components/RoomAvailabilityCalendar';
import RoomBookingRulesModal from '../components/RoomBookingRulesModal';

const CloneBooking = () => {
    const [showRules, setShowRules] = useState(true);

    return (
        <div style={{ background: '#f9f9f9', minHeight: '100vh', paddingTop: '20px' }}>
            <RoomBookingRulesModal
                show={showRules}
                onClose={() => setShowRules(false)}
            />
            <div className="container">
                <div className="text-center mb-5">
                    <h1 className="display-5 fw-bold" style={{ color: '#840000' }}>Check Room Availability</h1>
                    <p className="lead">Select a date to check availability and book your room.</p>
                </div>
                <RoomAvailabilityCalendar />
            </div>
        </div>
    );
};

export default CloneBooking;
